import React from "react";
import Nav from "../Nav";
import Footer from  "../Footer";
import LoginFA from "../LoginFA";

export default function Login(){

    return(
    <div>
        <Nav/>
        <LoginFA/>
        <Footer />
    </div>
    
    )
    
    }